var _metadata, _defs, _style, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLines(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 1080 2340"
    },
    viewBox: "0 0 1080 2340",
    y: 0,
    x: 0,
    id: "Layer_1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata49"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs47"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, "\n\t\n\t.st0{opacity:5.000000e-02;fill:none;stroke:#FFFFFF;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{opacity:0.15;fill:none;stroke:#FFFFFF;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{opacity:0.2;fill:none;stroke:#FFFFFF;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{opacity:0.1;fill:none;stroke:#FFFFFF;stroke-width:16;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "line4",
    y2: 1085.3,
    x2: 629.1,
    y1: 2020,
    x1: -374.8,
    className: "st0"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "line6",
    y2: 1012.1,
    x2: 1041.3,
    y1: 1046.5,
    x1: 1004.3,
    className: "st1"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "line8",
    y2: 1089.8,
    x2: 957.8,
    y1: 1883.1,
    x1: 105.7,
    className: "st1"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "line10",
    y2: 1284.9,
    x2: 1152.9,
    y1: 2078.2,
    x1: 300.8,
    className: "st2"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "line12",
    y2: 1486.5,
    x2: 1152.9,
    y1: 1607.6,
    x1: 1022.8,
    className: "st2"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "line14",
    y2: 1958.9,
    x2: 645.5,
    y1: 2192.7,
    x1: 394.3,
    className: "st2"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "line16",
    y2: 2226.8,
    x2: 357.8,
    y1: 2494.6,
    x1: 70.1,
    className: "st2"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "line18",
    y2: 1701.3,
    x2: 1152.9,
    y1: 1839.6,
    x1: 1004.3,
    className: "st1"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "line20",
    y2: 1883,
    x2: 957.8,
    y1: 2057.5,
    x1: 770.3,
    className: "st1"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "line22",
    y2: 2163,
    x2: 657.1,
    y1: 2494.6,
    x1: 300.8,
    className: "st1"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "line24",
    y2: 1813.2,
    x2: 1264.7,
    y1: 2086.9,
    x1: 970.7,
    className: "st3"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "line26",
    y2: 2126.6,
    x2: 928.1,
    y1: 2137.4,
    x1: 916.5,
    className: "st3"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "line28",
    y2: 2186.2,
    x2: 864,
    y1: 2606.5,
    x1: 412.7,
    className: "st3"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "line30",
    y2: 1927.3,
    x2: 1378.9,
    y1: 2255,
    x1: 1026.9,
    className: "st0"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "line32",
    y2: 2289.3,
    x2: 990,
    y1: 2720.6,
    x1: 526.8,
    className: "st0"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "line34",
    y2: 1942.2,
    x2: 42.3,
    y1: 1946.7,
    x1: 37.4,
    className: "st1"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "line36",
    y2: 531.1,
    x2: 1381.2,
    y1: 1190.9,
    x1: 672.6,
    className: "st3"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "line38",
    y2: 1244.8,
    x2: 614.7,
    y1: 1465.8,
    x1: 377.3,
    className: "st3"
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "line40",
    y2: 1590.8,
    x2: 614.7,
    y1: 1811.8,
    x1: 377.3,
    className: "st2"
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "line42",
    y2: 1311.8,
    x2: 910,
    y1: 1532.8,
    x1: 672.6,
    className: "st2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.a8622758f8047c9d43de8f6aaf8f3733.svg";
export { ForwardRef as ReactComponent };